export const medaliaGenAiConfigurationObject = (
  country: string,
  language: string,
) => {
    return {
      surveyType: 'RestOfWeb',
      surveyLangCountryCode: `${language}-${country}`,
      surveyLangCode: language,
      surveyCountryCode: country,
      surveyBrandType: 'SE',
      genAiPage: 'True',
    };
};
